import React from 'react';

import icon from './mobile_share.svg';

const MobileSharePopup: React.StatelessComponent = ({ children }) => (
  <div
    className="row jg-space-phsm jg-space-ptlg jg-display-flex jg-flex-aic"
    style={{ height: '100vh' }}
  >
    <div className="col-md-12 jg-text--center">
      <img
        src={icon}
        alt="People sharing the page via Whatsapp"
        className="jg-space-mbmd"
      />
      {children}
    </div>
  </div>
);

export default MobileSharePopup;



// WEBPACK FOOTER //
// ./src/components/SharePopup/MobileSharePopup.tsx